import type { FC } from 'react'

import Link from 'next/link'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Check, X } from 'lucide-react'
import { formatNumber, pluralize } from '@/lib/format'
import { useCart } from '@/components/order/cart-provider'

// A quiet confirmation after adding something to the order from any page.
export const CartToast: FC = () => {
    const router = useRouter()
    const { notice, dismissNotice, count } = useCart()
    const onOrderPage = router.pathname === '/order'

    useEffect(() => {
        if (!notice) return

        const timeout = window.setTimeout(dismissNotice, 5000)

        return () => window.clearTimeout(timeout)
    }, [notice, dismissNotice])

    useEffect(() => {
        if (onOrderPage && notice) dismissNotice()
    }, [onOrderPage, notice, dismissNotice])

    return (
        <div aria-live='polite' className='pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))]'>
            {notice && !onOrderPage && (
                <div key={notice.id} className='pointer-events-auto flex w-full max-w-md animate-in items-center gap-4 rounded-sm bg-foreground py-3 pe-2 ps-5 text-background duration-500 fade-in slide-in-from-bottom-3 motion-reduce:animate-none'>
                    <Check className='size-4 shrink-0 text-amber-wash' aria-hidden='true' />

                    <p className='min-w-0 flex-1 text-sm leading-snug'>
                        <span className='font-medium'>{notice.name}</span>
                        {notice.quantity > 1 && <span> × {formatNumber(notice.quantity)}</span>}
                        {' '}به سبد اضافه شد. حالا {pluralize(count, 'عدد')} در سبد سفارش دارید.
                    </p>

                    <Link href='/order' onClick={dismissNotice} className='shrink-0 px-2 py-2 text-sm font-medium underline decoration-background/40 underline-offset-4 hover:decoration-background focus-visible:outline-2 focus-visible:outline-amber-wash'>
                        دیدن سبد سفارش
                    </Link>

                    <button type='button' onClick={dismissNotice} aria-label='بستن' className='inline-flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-sm text-background/70 hover:text-background focus-visible:outline-2 focus-visible:outline-amber-wash'>
                        <X className='size-4' aria-hidden='true' />
                    </button>
                </div>
            )}
        </div>
    )
}
